export const steps = ['Prepare', 'Deposit', 'Sale Ends', 'Distribute']
